module.exports = __webpack_public_path__ + "static/media/dammLemonMug.98ed1668.jpg";